import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-emerald-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-end">
          {/* Text Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider bg-emerald-100 px-4 py-2 rounded-full">
                About Dolphin Power
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              A Family-Run Business in the Heart of South Devon
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed">
              Dolphin Power is run by Carrie and Jennie. We keep energy simple and friendly for cafés, B&Bs, and shops across South Devon.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Born from our love for the coast we call home, we're dedicated to supporting the local businesses that make our community thrive. We understand the unique challenges you face because we're part of this community too.
            </p>

            {/* Mission Statement */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-emerald-500 mt-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
              <p className="text-gray-700 leading-relaxed">
                Our mission is to make energy clear, simple, and supportive for the small businesses that shape South Devon. We help cafés, B&Bs, shops, and local enterprises feel confident in their energy choices by providing calm, friendly guidance without jargon or pressure.
              </p>
            </div>
          </div>

          {/* South Devon Harbor Sunset Photo */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl group">
              {/* The harbor sunset photo */}
              <div className="aspect-[4/5] relative overflow-hidden">
                <img 
                  src="/assets/harbor-sunset.webp"
                  alt="Beautiful sunset over South Devon harbor with boats and coastline"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                {/* Subtle gradient overlay for text readability if needed */}
                <div className="absolute inset-0 bg-gradient-to-t from-teal-900/20 via-transparent to-transparent"></div>
              </div>
              
              {/* Decorative elements */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-emerald-200 rounded-full opacity-30 blur-2xl"></div>
              <div className="absolute -top-6 -left-6 w-32 h-32 bg-teal-200 rounded-full opacity-30 blur-2xl"></div>
              
              {/* Optional caption overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-teal-900/80 to-transparent p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-white text-sm font-medium">The beautiful South Devon coast we call home</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;